module.exports = __webpack_public_path__ + "static/media/deal2.a2372c2d.jpg";